import React, { useEffect, useState } from 'react';
import { Card, Layout, Typography, Space, Button, Row, Col } from 'antd';
import AccessPolicyObjectSettings from './AccessPolicyObjectSettings';
import AccessPolicySystemSetting from './AccessPolicySystemSettings';
import AccessPolicyAppSettings from './AccessPolicyAppPermission';
import ApiService from '../Components/apiService';
import { BASE_URL, DateTimeFormat } from '../Components/Constant';
import { ArrowLeftOutlined } from "@ant-design/icons";
import dayjs from 'dayjs';
import {convertDateToUserTimezone} from '../Components/Utility';


const { Header, Content } = Layout;
const { Title } = Typography;

const AccessPolicyDetailPage = ({ users,selectedAccessPolicy,onMain }) => {

    const [showAppSettings, setShowAppSettings] = useState(false);
    const [showObjectSettings, setShowObjectSettings] = useState(false);
    const [showSystemSetting, setShowSystemSettings] = useState(false);
    const [accessPolicyData,setAccessPolicyData]=useState();
    const [objectSettingsData,setObjectSettingsData]=useState([]);
    const [systemSettingsData,setSystemSettingsData]=useState([]);
    const [appsettingsData,setAppSettingsData]=useState([]);
    


    useEffect(()=>{
        getAccessPolicyData();
    },[selectedAccessPolicy]);

    const getAccessPolicyData=async()=>{

        try{
            const apiService = new ApiService(
                `${BASE_URL}/get_access_policy/${selectedAccessPolicy?._id}`,
                { 'Content-Type': 'application/json' },
                'GET'
            );
            const response = await apiService.makeCall();

            setAccessPolicyData(response);
            setObjectSettingsData(response?.object_settings);
            setSystemSettingsData(response?.system_settings);
            setAppSettingsData(response?.app_settings);
        }
        catch(error){
            console.log(error);
        }
    }


    const handleAppPermission=()=>{
        setShowAppSettings(true);
    }

    const handleObjectPermission=()=>{
        setShowObjectSettings(true);
    }

    const handleSystemPermission=()=>{
        setShowSystemSettings(true);
    }

    const getUserNameById = (userId) => {
        const user = users.find((user) => user._id === userId);
        return user ? user.Name : '';
    };


    return (
        showObjectSettings ? (
            <AccessPolicyObjectSettings 
            selectedAccessPolicy={selectedAccessPolicy?._id} 
            onBack={()=>setShowObjectSettings(false)}
            objectSettingsData={objectSettingsData}
            accessPolicyData={accessPolicyData}
            onMain={onMain}
            />
        ) : showSystemSetting ? (
            <AccessPolicySystemSetting 
             selectedAccessPolicy={selectedAccessPolicy?._id}
             onBack={()=>setShowSystemSettings(false)}
             systemSettingsData={systemSettingsData}
             accessPolicyData={accessPolicyData}
             onMain={onMain}
              /> 
        ) : showAppSettings ? (
            <AccessPolicyAppSettings
            selectedAccessPolicy={selectedAccessPolicy?._id}
            accessPolicyData={accessPolicyData}
            appsettingsData={appsettingsData}
            onBack={()=>setShowAppSettings(false)}
            onMain={onMain}
             />

        ) : (
            <Layout style={{height:'80vh',overflowY:'scroll'}}>
                <Header s style={{ backgroundColor: 'transparent',display: "flex", justifyContent: "space-between", marginBottom: "16px" }}>
                    <Title level={3} style={{ margin: '20px', marginLeft: 0 }}>Access Policy Details</Title>
                    <Button style={{marginTop:'15px'}} icon={<ArrowLeftOutlined />} onClick={onMain}>Back</Button>
                </Header>
    
                <Card style={{ margin: '20px' }}>
                    <Row gutter={16}>
                        <Col span={12}>
                            <div>
                                <strong>Name</strong> <span style={{ marginLeft: '10px' }}>{selectedAccessPolicy.Name}</span>
                            </div>
                        </Col>
                        <Col span={12}>
                            <div>
                                <strong>Created By</strong> <span style={{ marginLeft: '10px' }}>{getUserNameById(selectedAccessPolicy.CreatedBy_id)}</span>
                            </div>
                        </Col>
                    </Row>
    
                    <Row gutter={16}>
                        <Col span={12}>
                            <div>
                                <strong>Created At</strong> <span style={{ marginLeft: '10px' }}>  {convertDateToUserTimezone(selectedAccessPolicy.created_at, DateTimeFormat)}
                                </span>
                            </div>
                        </Col>
                        <Col span={12}>
                            <div>
                                <strong>Updated By</strong> <span style={{ marginLeft: '10px' }}>{getUserNameById(selectedAccessPolicy.LastModifiedBy_id)}</span>
                            </div>
                        </Col>
                    </Row>
                </Card>
    
                <Content style={{ padding: '20px'}}>
                    <Space direction="vertical" size="large" style={{ width: '100%' }}>
                    <Card title="Assigned to Users" bordered={false}>
                            <p>Description for Assigned Users</p>
                            <div>
                                {selectedAccessPolicy?.assigned_to_ids && selectedAccessPolicy?.assigned_to_ids.length > 0 ? (
                                    <ul>
                                        {selectedAccessPolicy.assigned_to_ids.map((userId, index) => (
                                            <li key={index}>{getUserNameById(userId)}</li>
                                        ))}
                                    </ul>
                                ) : (
                                    <p>No users assigned.</p>
                                )}
                            </div>
                        </Card>

                        {/* App Settings Section */}
                        <Card title="App Settings" bordered={false}>
                            <p>Description for App Settings</p>
                            <Space direction="vertical">
                                <Button type="link" onClick={handleAppPermission}>App Permission</Button>
                            </Space>
                        </Card>
    
                        {/* Object Settings Section */}
                        <Card title="Object Settings" bordered={false}>
                            <p>Permissions to access objects and fields</p>
                            <Space direction="vertical">
                                <Button type="link" onClick={handleObjectPermission}>Object Settings</Button>
                            </Space>
                        </Card>
    
                        {/* System Settings Section */}
                        <Card title="System Settings" bordered={false}>
                            <p>Settings that apply across all apps, such as record and user management</p>
                            <Space direction="vertical">
                                <Button type="link" onClick={handleSystemPermission}>System Permissions</Button>
                            </Space>
                        </Card>
                    </Space>
                </Content>
            </Layout>
        )
    );
    
    
}

export default AccessPolicyDetailPage;
